/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_passkeys_help_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkeys are a secure, passwordless authentication method that uses your device's biometric authentication (fingerprint, face recognition) or PIN. They're more secure than passwords and easier to use.`)
};

const zh_hans1_settings_passkeys_help_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通行密钥是一种安全的无密码身份验证方法，使用设备的生物识别身份验证（指纹、面部识别）或 PIN 码。它们比密码更安全且更易于使用。`)
};

const zh_hant1_settings_passkeys_help_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通行金鑰是一種安全的無密碼身分驗證方式，使用裝置的生物辨識（指紋、臉部辨識）或 PIN。它比密碼更安全，也更容易使用。`)
};

const fr_settings_passkeys_help_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les passkeys sont une méthode d’authentification sécurisée et sans mot de passe, utilisant l’authentification biométrique (empreinte, reconnaissance faciale) ou un code PIN. Elles sont plus sûres que les mots de passe et plus simples à utiliser.`)
};

const de_settings_passkeys_help_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkeys sind eine sichere, passwortlose Authentifizierungsmethode, die die biometrische Authentifizierung (Fingerabdruck, Gesichtserkennung) oder eine PIN deines Geräts nutzt. Sie sind sicherer als Passwörter und einfacher zu verwenden.`)
};

const ja_settings_passkeys_help_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーは、端末の生体認証（指紋・顔認証）や PIN を使う、安全なパスワード不要の認証方式です。パスワードより安全で、より簡単に利用できます。`)
};

const ko_settings_passkeys_help_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패스키는 기기의 생체 인증(지문, 얼굴 인식) 또는 PIN을 사용하는 안전한 비밀번호 없는 인증 방식입니다. 비밀번호보다 안전하고 사용하기 쉽습니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_passkeys_help_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_passkeys_help_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_passkeys_help_text", locale)
	if (locale === "en") return en_settings_passkeys_help_text(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_passkeys_help_text(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_passkeys_help_text(inputs)
	if (locale === "fr") return fr_settings_passkeys_help_text(inputs)
	if (locale === "de") return de_settings_passkeys_help_text(inputs)
	if (locale === "ja") return ja_settings_passkeys_help_text(inputs)
	return ko_settings_passkeys_help_text(inputs)
};